class ScoutingLabelsController {
  private labelsHolder;
  private playerId;
  private onUpdateTable;

  constructor(
    private ScoutingLabelsResource,
    private $filter,
    private $uibModal,
  ) {}

  async removeLabel(label) {
    const labelName = label.label.name;
    const modalTitle = 'Remove from List';

    const confirmationText = this.$filter('translate')('scouting.Delete_list_confirmation', {
      listName: labelName,
    });

    const modalInstance = this.$uibModal.open({
      size: 'md',
      template: `
        <div class="sc-modal">
          <div class="modal-header">
            <h3 class="modal-title">${modalTitle}</h3>
          </div>
          <div class="modal-body md-body-1">
            <strong>${confirmationText}</strong>
          </div>
          <div class="modal-footer">
            <div layout layout-align="space-between center" class="m-n">
              <md-button class="md-raised" ng-click="$ctrl.cancel()">
                Cancel
              </md-button>
              <md-button class="md-primary md-raised" ng-click="$ctrl.confirm()">
                Remove
              </md-button>
            </div>
          </div>
        </div>
      `,
      controller: [
        '$uibModalInstance',
        function ($uibModalInstance) {
          this.modalInstance = $uibModalInstance;

          this.cancel = function () {
            $uibModalInstance.dismiss('cancel');
          };

          this.confirm = function () {
            $uibModalInstance.close('confirm');
          };
        },
      ],
      controllerAs: '$ctrl',
    });

    try {
      const result = await modalInstance.result;

      if (result === 'confirm') {
        const idx = this.labelsHolder.labels.indexOf(label);
        if (idx >= 0) {
          this.labelsHolder.labels.splice(idx, 1);
        }

        await this.ScoutingLabelsResource.removePlayers(
          { id: label._id },
          { players: [{ _id: this.playerId }] },
        ).$promise;

        if (this.onUpdateTable) {
          this.onUpdateTable();
        }
      }
    } catch (_e) {
      // Do nothing
    }
  }
}

angular.module('app.scouting').component('scoutingLabels', {
  templateUrl: 'scouting/components/general/labels.html',
  controller: ScoutingLabelsController,
  bindings: {
    labelsHolder: '<',
    playerId: '<',
    onUpdateTable: '&',
  },
});
